import { useEffect, useRef, useState } from "react";

// Trava de aba única: só uma aba do navegador vota por vez (evita voto duplicado/estado diferente entre abas).
// A aba "dona" renova um carimbo no localStorage; as outras ficam bloqueadas até assumir ou a dona fechar.
const CHAVE = "va-votar-aba";
const BATIDA_MS = 2000;
const VALIDADE_MS = 6000;

const ler = () => {
  try {
    return JSON.parse(localStorage.getItem(CHAVE));
  } catch (e) {
    return null;
  }
};

const gravar = id => {
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ id, ts: Date.now() }));
  } catch (e) {
    /* sem armazenamento: não há como coordenar abas */
  }
};

export const donoAtivo = (registro, agora = Date.now()) => !!registro && agora - registro.ts < VALIDADE_MS;

export const liberarAba = id => {
  const atual = ler();
  if (atual && atual.id === id) {
    try {
      localStorage.removeItem(CHAVE);
    } catch (e) {
      /* nada a liberar */
    }
  }
};

export default function useAbaUnica() {
  const idRef = useRef(`${Date.now()}-${Math.random().toString(16).slice(2)}`);
  const [ativa, setAtiva] = useState(() => {
    const dono = ler();
    return !donoAtivo(dono) || dono.id === idRef.current;
  });
  const ativaRef = useRef(ativa);
  ativaRef.current = ativa;

  useEffect(() => {
    const id = idRef.current;
    if (ativaRef.current) gravar(id);

    const verificar = () => {
      const dono = ler();
      if (ativaRef.current) {
        if (dono && dono.id !== id && donoAtivo(dono)) setAtiva(false);
        else gravar(id);
      } else if (!donoAtivo(dono)) {
        // a aba dona foi fechada: esta assume
        gravar(id);
        setAtiva(true);
      }
    };

    const intervalo = setInterval(verificar, BATIDA_MS);
    const aoMudar = e => {
      if (e.key === CHAVE) verificar();
    };
    const aoFechar = () => liberarAba(id);
    window.addEventListener("storage", aoMudar);
    window.addEventListener("pagehide", aoFechar);
    return () => {
      clearInterval(intervalo);
      window.removeEventListener("storage", aoMudar);
      window.removeEventListener("pagehide", aoFechar);
      liberarAba(id);
    };
  }, []);

  const assumir = () => {
    gravar(idRef.current);
    setAtiva(true);
  };

  return { ativa, assumir };
}
